<template>
  <div class="footer">
    <div class="container">
      <NuxtLink class="logo-link" to="/">
        <img src="/images/logo.png" class="logo" alt="logo" />
      </NuxtLink>
      <div class="text-line">
        <a class="link" :class="{ active: currentPage === 'about' }" href="/about" target="_blank">关于我们</a>
        &nbsp;|&nbsp;
        <a class="link" :class="{ active: currentPage === 'product' }" href="/product" target="_blank">产品介绍</a>
        &nbsp;|&nbsp;
        <a class="link" :class="{ active: currentPage === 'userAgreement' }" href="/userAgreement" target="_blank">
          用户协议
        </a>
        &nbsp;|&nbsp;
        <a
          class="link"
          :class="{ active: currentPage === 'softwareAgreement' }"
          href="/softwareAgreement"
          target="_blank"
        >
          软件许可协议
        </a>
        &nbsp;|&nbsp;
        <a class="link" :class="{ active: currentPage === 'privacyPolicy' }" href="/privacyPolicy" target="_blank">
          隐私政策
        </a>
      </div>
      <div class="text-line">
        <a class="link" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2024106783号</a>
      </div>
      <div class="text-line">杭州曲末网络科技有限公司版权所有©2024-2025</div>
      <div class="text-line">地址：浙江省杭州市余杭区余杭街道义创路5-11号2幢296室</div>
      <div class="divider"></div>
      <div class="text-line">
        健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
      </div>
      <div class="text-line">违法和不良信息举报邮箱：youxi@hzqumokj.cn</div>
      <div class="text-line">
        <a class="link" href="https://jbts.mct.gov.cn/" target="_blank">全国文化市场统一举报电话：12318</a>
        |
        <a class="link" href="https://www.shdf.gov.cn/shdf/channels/740.html" target="_blank">扫黄打非举报</a>
      </div>
      <div class="text-line">
        亲爱的市民朋友，浙江警方反诈劝阻电话“96110”系专门针对避免您财产被骗受损而设，请您一旦收到来电，立即接听。
      </div>
      <div class="gov-unit-container">
        <span class="gov-unit">
          <ClientOnly>
            <img v-if="!isMobile()" src="/images/hlwwhjydw.png" class="gov-unit-logo" />
          </ClientOnly>
          互联网文化经营单位
        </span>
        <a href="https://www.12377.cn/" target="_blank" class="gov-unit link">
          <ClientOnly>
            <img v-if="!isMobile()" src="/images/wsyhxxjbzq.png" class="gov-unit-logo" />
          </ClientOnly>
          网上有害信息举报专区
        </a>
        <br />
        <a href="https://www.hangzhoujubao.com/" target="_blank" class="gov-unit link">
          <ClientOnly>
            <img v-if="!isMobile()" src="/images/hzhlwwfhblxxjbzx.png" class="gov-unit-logo" />
          </ClientOnly>
          杭州市互联网违法和不良信息举报中心
        </a>
      </div>
      <div class="qrcode-container">
        联系我们
        <img src="/images/wechatQrcode.jpg" alt="qrcode" class="qrcode" />
        <div class="bottom">
          <div class="line"></div>
          微信公众号
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { isMobile } from '@/utils/systemInfo'

const route = useRoute()
const currentPage = computed(() => route.name)
</script>

<style scoped lang="scss">
@media screen and (orientation: landscape) {
  .footer {
    width: 100%;
    min-width: 1440px;
    height: 100vh;
    min-height: 800px;
    background-position: center;
    background-size: 1920px;
    background-repeat: no-repeat;
    background-color: #000000;
    padding-top: 90px;

    .container {
      width: 1440px;
      margin: 0 auto;
      color: #c0c8df;
      position: relative;

      .qrcode-container {
        position: absolute;
        top: 0;
        right: 0;
        color: #ffffff;
        font-size: 18px;
        text-align: center;

        .qrcode {
          margin: 16px 0;
          display: block;
          width: 176px;
          height: 176px;
        }

        .bottom {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .line {
            width: 28px;
            height: 1px;
            background: #ffffff;
          }
        }
      }

      .logo-link {
        margin-bottom: 100px;
        width: 222px;
        display: block;

        .logo {
          width: 222px;
        }
      }

      .link {
        color: #c0c8df;

        &:hover {
          color: #ffffff;
        }
      }

      .active {
        color: #ffffff;
      }

      .text-line {
        margin-bottom: 16px;
      }

      .divider {
        height: 1px;
        background-color: #96a0bb;
        margin: 60px 0;
        opacity: 0.25;
      }

      .gov-unit-container {
        display: flex;

        .gov-unit {
          padding: 0 12px;
          height: 44px;
          display: flex;
          align-items: center;
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.05);
          margin-right: 8px;

          .gov-unit-logo {
            height: 32px;
            margin-right: 6px;
          }
        }
      }
    }
  }
}

@media screen and (orientation: portrait) {
  .footer {
    width: 100vw;
    height: 100vh;
    min-height: 800rem;
    margin-top: -2rem;
    background-image: linear-gradient(to bottom, rgba(18, 21, 23, 1), rgba(42, 43, 52, 1));
    background-position: center;
    background-size: 1920px;
    background-repeat: no-repeat;
    padding: 24rem 16rem;
    font-size: 12rem;
    line-height: 18rem;
    text-align: center;

    .container {
      width: 100%;
      margin: 0 auto;
      color: #c0c8df;
      position: relative;

      .logo {
        display: block;
        margin: 0 auto;
        width: 162.5rem;
        margin-bottom: 24rem;
      }

      .link {
        color: #c0c8df;
      }

      .text-line {
        margin-bottom: 16rem;
      }

      .divider {
        height: 1rem;
        background-color: #96a0bb;
        margin: 24rem 0;
        opacity: 0.25;
      }

      .gov-unit-container {
        .gov-unit {
          padding: 0 6rem;
        }
      }

      .qrcode-container {
        color: #ffffff;
        text-align: center;
        font-size: 16rem;
        width: 140rem;
        height: 198rem;
        margin: 24rem auto;

        .qrcode {
          margin: 12rem 0;
          display: block;
          width: 140rem;
          height: 140rem;
        }

        .bottom {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .line {
            width: 22rem;
            height: 1rem;
            background: #ffffff;
          }
        }
      }
    }
  }
}
</style>
